var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 20C4 18 4 5 4 5C4 3.34315 5.4327 2 7.2 2H20V18C20 18 9.99075 18 7.2 18C4.68112 18 4 18.3421 4 20Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 2.75C5.80058 2.75 4.75 3.80222 4.75 5H4H3.25C3.25 2.88407 5.06482 1.25 7.2 1.25H20C20.4142 1.25 20.75 1.58579 20.75 2V18C20.75 18.4142 20.4142 18.75 20 18.75V18C20 18.75 20.0001 18.75 20 18.75H7.2C6.58121 18.75 6.10701 18.7714 5.74037 18.8222C5.36986 18.8736 5.16202 18.9486 5.04293 19.0204C4.90495 19.1037 4.75 19.2497 4.75 20C4.75 20.4142 4.41421 20.75 4 20.75C3.58579 20.75 3.25 20.4142 3.25 20V5C3.25 4.9999 3.25 5 4 5C4.75 5 4.75 4.9999 4.75 5V17.5144C4.9955 17.43 5.25953 17.3746 5.53433 17.3365C6.00383 17.2714 6.55935 17.25 7.2 17.25H19.25V2.75H7.2Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.25 20C3.25 18.4812 4.48121 17.25 6 17.25H20C20.4142 17.25 20.75 17.5858 20.75 18V22C20.75 22.4142 20.4142 22.75 20 22.75H6C4.48121 22.75 3.25 21.5188 3.25 20ZM6 18.75C5.30965 18.75 4.75 19.3097 4.75 20C4.75 20.6903 5.30965 21.25 6 21.25H19.25V18.75H6Z",
    fill: "#1C1B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaw);
export default __webpack_public_path__ + "static/media/Law.5b45df1f.svg";
export { ForwardRef as ReactComponent };